export interface CreatePortfolioRequest {
  reference?: string
  earningProductId: string
}

export interface DepositRequest {
  portfolioId: string
  reference: string
  originator: Counterparty
}

export interface WithdrawalRequest {
  portfolioId: string
  reference: string
  beneficiary: Counterparty
}

export interface Counterparty {
  walletId: string
  amount: string
}

export const PortfolioStatus = {
  CREATED: 'CREATED',
  ACTIVE: 'ACTIVE',
  CLOSED: 'CLOSED',
} as const

export type PortfolioStatus = (typeof PortfolioStatus)[keyof typeof PortfolioStatus]

export const TransferStatus = {
  PENDING: 'PENDING',
  COMPLETED_ON_LEDGER: 'COMPLETED_ON_LEDGER',
  SETTLED_WITH_PORTFOLIO: 'SETTLED_WITH_PORTFOLIO',
  FAILED: 'FAILED',
} as const

export type TransferStatus = (typeof TransferStatus)[keyof typeof TransferStatus]

export interface Portfolio {
  id: string
  object: 'portfolio'
  reference?: string | null
  walletId?: string | null
  currency: string
  status: PortfolioStatus
  balance: string
  totalEarnedAmount: string
  createdAt: string
  updatedAt: string
}

export interface TransferAmount {
  amount: string
  currency: string
}

export interface DepositTransferResponse {
  id: string
  object: string
  reference: string
  status: TransferStatus
  portfolioId: string
  depositAmount: TransferAmount
  originatorWalletId: string
  balance: TransferAmount
  createdAt: string
  updatedAt: string
}

export interface WithdrawalTransferResponse {
  id: string
  object: string
  reference: string
  status: TransferStatus
  portfolioId: string
  withdrawalAmount: TransferAmount
  beneficiaryWalletId: string
  balance: TransferAmount
  createdAt: string
  updatedAt: string
}

export interface GetPortfoliosResponse {
  content: Portfolio[]
  totalElements: number
  pageable: Pageable
}

export interface Pageable {
  pageNumber: number
  pageSize: number
}

export interface RewardsProduct {
  id: string
  object: string
  currency: string
  earningRate: number
}

export interface GetRewardsProductsResponse {
  content: RewardsProduct[]
  totalElements: number
  pageable?: {
    pageNumber: number
    pageSize: number
  }
}

export interface GetRewardsProductsParams {
  pageNumber?: number
  pageSize?: number
  currency?: string
}

export interface GetPortfoliosParams {
  pageNumber?: number
  pageSize?: number
}

export interface CustomerEarningsSummaryParams {
  currency: string
  type: string
}

export interface CustomerEarningsSummaryResponse {
  totalBalance: string
  totalUnpaidEarnings: string
  totalEarnedAmount: string
  currency: string
}

export interface MonthlyCustomersEarnings {
  id: string
  object: 'monthlyCustomersEarnings'
  amount: string
  currency: string
  earningsPeriodEnd: string
  createdAt: string
  updatedAt: string
}

export interface GetMonthlyCustomersEarningsResponse {
  content: MonthlyCustomersEarnings[]
  totalElements: number
  pageable: Pageable
}

export interface GetMonthlyCustomersEarningsParams {
  currency: string
  startDate?: string
  endDate?: string
  pageNumber?: number
  pageSize?: number
}

export interface DistributionRequest {
  destinationWalletId: string
  reference: string
}

export interface CreateDistributionRuleRequest {
  destinationWalletId: string
  reference: string
}

export interface EarningsDistributionResponse {
  accountId: string
  currency: string
  automatic: boolean
}

export interface MultiFactorAuthorizationRequest {
  challenge: string
  tokenResponse: string
}
